module.exports = __webpack_public_path__ + "static/media/logo-color.39b82f20.png";